import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'anms-big-input-action',
    templateUrl: './big-input-action.component.html',
    styleUrls: ['./big-input-action.component.scss'],
    imports: [MatButtonModule, MatIconModule]
})
export class BigInputActionComponent {
  readonly disabled = input(false);
  readonly icon = input('');
  readonly label = input('');
  readonly color = input('');

  readonly action = output<void>();

  hasFocus = false;

  onClick() {
    // TODO: The 'emit' function requires a mandatory void argument
    this.action.emit();
  }
}
